import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClearContainerStationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type ClearContainerStationMutation = { __typename?: 'Mutation', clearContainerStation: { __typename?: 'ContainerStation', id: string, name: string, containers: Array<{ __typename?: 'ContainerStationContainer', id: string, name: string, image_url?: string | null, status: Types.ContainerLocationStatus }> } };


export const ClearContainerStationDocument = gql`
    mutation clearContainerStation($id: ID!) {
  clearContainerStation(id: $id) {
    id
    name
    containers {
      id
      name
      image_url
      status
    }
  }
}
    `;
export type ClearContainerStationMutationFn = Apollo.MutationFunction<ClearContainerStationMutation, ClearContainerStationMutationVariables>;

/**
 * __useClearContainerStationMutation__
 *
 * To run a mutation, you first call `useClearContainerStationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearContainerStationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearContainerStationMutation, { data, loading, error }] = useClearContainerStationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClearContainerStationMutation(baseOptions?: Apollo.MutationHookOptions<ClearContainerStationMutation, ClearContainerStationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearContainerStationMutation, ClearContainerStationMutationVariables>(ClearContainerStationDocument, options);
      }
export type ClearContainerStationMutationHookResult = ReturnType<typeof useClearContainerStationMutation>;
export type ClearContainerStationMutationResult = Apollo.MutationResult<ClearContainerStationMutation>;
export type ClearContainerStationMutationOptions = Apollo.BaseMutationOptions<ClearContainerStationMutation, ClearContainerStationMutationVariables>;